import { AppRoutes } from '../types';

export type PageVisibilityKey =
  | 'home'
  | 'about'
  | 'products'
  | 'productDetail'
  | 'shop'
  | 'cart'
  | 'checkout'
  | 'orderConfirmation'
  | 'orderHistory'
  | 'journal'
  | 'journalPost'
  | 'faq'
  | 'petServices'
  | 'contact'
  | 'shipping'
  | 'privacy'
  | 'terms'
  | 'styleGuide'
  | 'login'
  | 'account'
  | 'petProfile'
  | 'trackOrder';

export interface PageVisibilityItem {
  key: PageVisibilityKey;
  label: { en: string; 'zh-hk': string };
  route?: AppRoutes;
  showInNav?: boolean;
  showInFooter?: boolean;
}

export const PAGE_VISIBILITY_ITEMS: PageVisibilityItem[] = [
  {
    key: 'home',
    label: { en: 'Home', 'zh-hk': '首頁' },
    route: AppRoutes.HOME,
  },
  {
    key: 'about',
    label: { en: 'About', 'zh-hk': '關於我們' },
    route: AppRoutes.ABOUT,
    showInNav: true,
    showInFooter: true,
  },
  {
    key: 'products',
    label: { en: 'Products', 'zh-hk': '產品系列' },
    route: AppRoutes.PRODUCTS,
    showInNav: true,
    showInFooter: true,
  },
  {
    key: 'productDetail',
    label: { en: 'Product Detail', 'zh-hk': '產品詳情' },
  },
  {
    key: 'shop',
    label: { en: 'Shop', 'zh-hk': '立即購買' },
    route: AppRoutes.SHOP,
  },
  {
    key: 'cart',
    label: { en: 'Cart', 'zh-hk': '購物車' },
    route: AppRoutes.CART,
  },
  {
    key: 'checkout',
    label: { en: 'Checkout', 'zh-hk': '結帳' },
    route: AppRoutes.CHECKOUT,
  },
  {
    key: 'orderConfirmation',
    label: { en: 'Order Confirmation', 'zh-hk': '訂單確認' },
    route: AppRoutes.ORDER_CONFIRMATION,
  },
  {
    key: 'orderHistory',
    label: { en: 'Order History', 'zh-hk': '訂單紀錄' },
    route: AppRoutes.ORDER_HISTORY,
  },
  {
    key: 'journal',
    label: { en: 'Journal', 'zh-hk': '日誌' },
    route: AppRoutes.JOURNAL,
    showInNav: true,
    showInFooter: true,
  },
  {
    key: 'journalPost',
    label: { en: 'Journal Post', 'zh-hk': '日誌文章' },
  },
  {
    key: 'faq',
    label: { en: 'FAQ', 'zh-hk': '常見問題' },
    route: AppRoutes.FAQ,
    showInNav: true,
    showInFooter: true,
  },
  {
    key: 'petServices',
    label: { en: 'Pet Services', 'zh-hk': '寵物服務' },
    route: AppRoutes.PET_SERVICES,
    showInNav: true,
    showInFooter: true,
  },
  {
    key: 'contact',
    label: { en: 'Contact', 'zh-hk': '聯絡我們' },
    route: AppRoutes.CONTACT,
    showInNav: true,
    showInFooter: true,
  },
  {
    key: 'shipping',
    label: { en: 'Shipping', 'zh-hk': '運送與退換' },
    route: AppRoutes.SHIPPING,
    showInFooter: true,
  },
  {
    key: 'privacy',
    label: { en: 'Privacy Policy', 'zh-hk': '私隱政策' },
    route: AppRoutes.PRIVACY,
    showInFooter: true,
  },
  {
    key: 'terms',
    label: { en: 'Terms & Conditions', 'zh-hk': '條款及細則' },
    route: AppRoutes.TERMS,
    showInFooter: true,
  },
  {
    key: 'styleGuide',
    label: { en: 'Style Guide', 'zh-hk': '設計規範' },
    route: AppRoutes.STYLE_GUIDE,
  },
  {
    key: 'login',
    label: { en: 'Login', 'zh-hk': '登入' },
    route: AppRoutes.LOGIN,
  },
  {
    key: 'account',
    label: { en: 'Account', 'zh-hk': '會員中心' },
    route: AppRoutes.ACCOUNT,
  },
  {
    key: 'petProfile',
    label: { en: 'Pet Profile', 'zh-hk': '寵物檔案' },
    route: AppRoutes.PET_PROFILE,
  },
  {
    key: 'trackOrder',
    label: { en: 'Track Order', 'zh-hk': '追蹤訂單' },
    route: AppRoutes.TRACK_ORDER,
  },
];

export type PageVisibilityMap = Record<PageVisibilityKey, boolean>;

export const DEFAULT_PAGE_VISIBILITY: PageVisibilityMap = PAGE_VISIBILITY_ITEMS.reduce(
  (acc, item) => {
    acc[item.key] = true;
    return acc;
  },
  {} as PageVisibilityMap
);

export const applyVisibilityOverrides = (
  items: Array<{ page_key: string; enabled: boolean }>
): PageVisibilityMap => {
  const map = { ...DEFAULT_PAGE_VISIBILITY };
  for (const item of items) {
    if (item.page_key in map) {
      map[item.page_key as PageVisibilityKey] = item.enabled;
    }
  }
  return map;
};
